import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import { Badge, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { useNotificationCenter } from '@/contexts/NotificationCenterProvider';

const VNMSNavBell = () => {
  const navigate = useNavigate();
  const { notifications, unreadCount } = useNotificationCenter();

  // Show only when the current OU has at least one live notification (read or unread)
  if (notifications.length === 0) {
    return null;
  }

  const ariaLabel = unreadCount > 0 ? `${unreadCount} notifications` : 'Notifications';

  return (
    <IconButton className="vnms-nav-bell" aria-label={ariaLabel} onClick={() => navigate('/notifications')}>
      <Badge overlap="circular" badgeContent={unreadCount} invisible={unreadCount <= 0} color="error">
        <NotificationsOutlinedIcon className="vnms-nav-bell__icon" />
      </Badge>
    </IconButton>
  );
};

export default VNMSNavBell;
